// src/data/floresDB.js
// IMPORTANTE: Asegúrate de que los nombres de archivo de imagen coincidan
// con los que coloques en la carpeta public/images/flowers/

export const floresDB = [
  {
    id: 1,
    nombreComun: "Rosa",
    nombreCientifico: "Rosa spp.",
    imagenUrl: "/images/flowers/rosa.jpg", // Ruta relativa a la carpeta 'public'
    familia: "Rosaceae",
    origen: "Principalmente Asia, Europa, América del Norte, África noroccidental.",
    coloresComunes: ["rojo", "rosa", "blanco", "amarillo", "naranja"],
    datosCuriosos: [
      "Símbolo universal del amor y la pasión.",
      "Existen más de 30,000 variedades cultivadas.",
      "Los escaramujos (frutos) son ricos en vitamina C."
    ],
    caracteristicasClave: ["Tiene espinas", "Arbusto o trepadora", "Fragante"],
    dificultad: "facil"
  },
  {
    id: 2,
    nombreComun: "Girasol",
    nombreCientifico: "Helianthus annuus",
    imagenUrl: "/images/flowers/girasol.jpg",
    familia: "Asteraceae",
    origen: "América del Norte y América Central.",
    coloresComunes: ["amarillo (pétalos)", "marrón/negro (centro)"],
    datosCuriosos: [
      "Siguen el movimiento del sol (heliotropismo) cuando son jóvenes.",
      "Sus semillas son comestibles y ricas en aceite.",
      "Puede alcanzar alturas de más de 3 metros."
    ],
    caracteristicasClave: ["Flor grande", "Pétalos amarillos", "Sigue al sol"],
    dificultad: "facil"
  },
  {
    id: 3,
    nombreComun: "Tulipán",
    nombreCientifico: "Tulipa spp.",
    imagenUrl: "/images/flowers/tulipan.jpg",
    familia: "Liliaceae",
    origen: "Asia Central, extendiéndose hasta el Mediterráneo.",
    coloresComunes: ["rojo", "amarillo", "rosa", "blanco", "morado", "naranja"],
    datosCuriosos: [
      "Originarios de Persia y Turquía, no de Holanda.",
      "Hubo una 'tulipomanía' en el siglo XVII donde los bulbos alcanzaron precios desorbitados.",
      "Hay más de 150 especies y más de 3,000 variedades."
    ],
    caracteristicasClave: ["Bulbosa", "Florece en primavera", "Forma de copa"],
    dificultad: "media"
  },
  {
    id: 4,
    nombreComun: "Orquídea Phalaenopsis",
    nombreCientifico: "Phalaenopsis spp.",
    imagenUrl: "/images/flowers/orquidea.jpg",
    familia: "Orchidaceae",
    origen: "Sudeste Asiático, Filipinas, Australia.",
    coloresComunes: ["blanco", "rosa", "morado", "amarillo", "con patrones"],
    datosCuriosos: [
      "Una de las familias de plantas con flores más grandes.",
      "Muchas son epífitas (crecen sobre otras plantas).",
      "La vainilla se obtiene del fruto de una especie de orquídea."
    ],
    caracteristicasClave: ["Flor exótica", "A menudo simétrica", "Raíces aéreas (algunas)"],
    dificultad: "media"
  },
  {
    id: 5,
    nombreComun: "Margarita Común",
    nombreCientifico: "Bellis perennis",
    imagenUrl: "/images/flowers/margarita.jpg",
    familia: "Asteraceae",
    origen: "Europa y norte de África.",
    coloresComunes: ["blanco (pétalos)", "amarillo (centro)"],
    datosCuriosos: [
      "Su nombre 'daisy' viene de 'day's eye' (ojo del día).",
      "Comúnmente asociada con la inocencia y la pureza."
    ],
    caracteristicasClave: ["Pétalos blancos radiales", "Centro amarillo", "Flor pequeña"],
    dificultad: "facil"
  }
  // Agrega más flores aquí
];